import { render, staticRenderFns } from "./SampleReviews.vue?vue&type=template&id=278e60b8"
import script from "./SampleReviews.vue?vue&type=script&lang=js"
export * from "./SampleReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports